import React, { useState, useRef, useEffect, useContext } from "react";
import { baseUrl } from '../../config.js'
import { Chart } from "react-google-charts";

import './Dashboards.css';
import './Calendar.css';

import useToken from "../../useToken.js";
import { formatoFecha, formatoFechaCorta, formatoMoneda, formatoHora, Meses, estatus, imgEstatus } from '../../almacen.js';

import Terminado from '../../img/Terminado.png';
import EnCurso from '../../img/EnCurso.png';
import Terminar from '../../img/Terminar.png';
import Esperando from '../../img/Created.png';
import Iniciar from '../../img/Iniciar.png';
import Cerrar from '../../img/Cerrar.png';
import FlechaGuia from '../../img/Guia.png';

import { Link, NavLink, useLocation, useNavigate, useParams } from "react-router-dom";

const Conds = {
    "0": "Exactamente",
    "1": "Entre",
    "2": "Más de",
    "3": "Menos de",
}
const CondsFecha = {
    "0": "",
    "1": "",
    "2": "A partir del",
    "3": "Antes del",
}

const DashInouts = ({solicitudes, setId})=>{

    const location = useLocation();

    return(
        <div className="dashEspacios dashInouts">
            <div className="movimientos">
                <div className="etiqueta">
                    <div>
                        <h3>{solicitudes ? 'Solicitudes de Reservación' : 'Reservaciones de In/Out'}</h3>
                        <Movimientos solicitudes={solicitudes} setId={setId}/>
                    </div>
                </div>
            </div>

        </div>
    )
}

const Movimientos = ({solicitudes, setId})=>{

    const { id } = useParams();
    const { token } = useToken();
    const navigate = useNavigate();
    const [vista, setVista] = useState('Lista');
    const [data, setData] = useState([]);
    const [totales, setTotales] = useState({});
    const [filtros, setFiltros] = useState({status:'Pendientes', requests: solicitudes});
    const [showFilter, setShowFilter] = useState('');
    const [fecha, setFecha] = useState(new Date())
    const [cargando, setCargando] = useState(false)
    const [tipoFiltro, setTipoFiltro] = useState('Todos');
    const modFiltrar = useRef();

    useEffect(()=>{
        if(token){
            getData();
        }
    },[token, filtros])

    const handleClickOutside = (event) => {
        if (modFiltrar.current && !modFiltrar.current.contains(event.target)) {
            setShowFilter('');
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    const getData = ()=>{
        setCargando(true);
        filtros.idBooking = id;
        fetch(baseUrl+'host/Info/Inouts',{
            method: 'post',
            headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
            body: JSON.stringify(filtros)
        })
        .then(response=>response.json())
		.then(json=>{
            setData(json?.data || [])
            setTotales(json?.total || {});
            setCargando(false);
		})
		.catch(error=>{
			console.error(error);
            setCargando(false);
		})
    }

    const generaIntervalo = (json) => {
        if(json.intervalo > 1){
            return "En los últimos " + json.intervalo + " " + json.tiempo;
        }
        const singular = {
            "Días" : "Día",
            "Meses" : "Mes",
            "Años" : "Año",
        }
        return "En el último " + singular[json.tiempo];

    }

    return(
        <>
            
            {!solicitudes &&
            <>
                <div className="res-filter-pills">
                    <button
                        className={`res-filter-pill ${filtros?.status == 'Total' ? 'active' : ''}`}
                        onClick={()=>{
                            setFiltros({...filtros, status: 'Total'});
                        }}
                    >
                        <span className="res-pill-label">Todos</span>
                        <span className="res-pill-count">{totales?.Total || 0}</span>
                    </button>
                    <button
                        className={`res-filter-pill ${filtros?.status == 'Pendientes' ? 'active' : ''}`}
                        onClick={()=>{
                            setFiltros({...filtros, status: 'Pendientes'});
                        }}
                    >
                        <span className="res-pill-label">Pendientes</span>
                        <span className="res-pill-count">{totales?.Pendientes || 0}</span>
                    </button>
                    <button
                        className={`res-filter-pill ${filtros?.status == 'Anteriores' ? 'active' : ''}`}
                        onClick={()=>{
                            setFiltros({...filtros, status: 'Anteriores'});
                        }}
                    >
                        <span className="res-pill-label">Anteriores</span>
                        <span className="res-pill-count">{totales?.Anteriores || 0}</span>
                    </button>
                </div>
            </>
            }
            <div className="navReservaciones">
                <button className={`navReservaciones-link ${vista == 'Lista' ? 'active' : ''}`} onClick={()=>{
                    setVista('Lista');
                }}>Lista</button>
                <button className={`navReservaciones-link ${vista == 'Calendario' ? 'active' : ''}`} onClick={()=>{
                    setVista('Calendario');
                }}>Calendario</button>
            </div>

            <div className="res-filter-pills" style={{marginTop: "10px", marginBottom: "15px"}}>
                <button
                    className={`res-filter-pill${tipoFiltro == 'Todos' ? ' active' : ''}`}
                    onClick={()=>{ setTipoFiltro('Todos'); }}
                >
                    <span className="res-pill-label">Todos</span>
                </button>
                <button
                    className={`res-filter-pill${tipoFiltro == 'Entradas' ? ' active' : ''}`}
                    onClick={()=>{ setTipoFiltro('Entradas'); }}
                >
                    <span className="res-pill-label">Entradas</span>
                </button>
                <button
                    className={`res-filter-pill${tipoFiltro == 'Salidas' ? ' active' : ''}`}
                    onClick={()=>{ setTipoFiltro('Salidas'); }}
                >
                    <span className="res-pill-label">Salidas</span>
                </button>
            </div>

            <div className="res-tools">
                {vista == "Lista" &&
                    <Lista cargando={cargando} data={data} tipoFiltro={tipoFiltro} setId={setId}/>
                }
                {vista == "Calendario" &&
                    <Calendario data={data} setId={setId}/>
                }
            </div>
        </>
    )
}

const Lista = ({cargando, data, tipoFiltro, setId})=>{
    return(
        <table className={"tabla pagos"+(cargando ? " cargandoTabla" : "")}>
            <tbody>
                {data?.length !== 0 &&
                    <tr className='header'>
                        <th>Almacén</th>
                        <th>Cliente</th>
                        <th>Importe (MXN)</th>
                        <th>Estatus</th>
                        <th>Tipo</th>
                        <th>Pallets</th>
                        <th>Fecha</th>
                        <th>Hora</th>
                    </tr>
                }
                {data?.filter(fila => {
                    if (tipoFiltro === 'Entradas') return fila.spacesIn > 0;
                    if (tipoFiltro === 'Salidas') return fila.spacesOut > 0;
                    return true;
                }).length === 0 &&
                    <tr>
                        <td colSpan="8" style={{textAlign: "center", padding: "20px"}}>No hay movimientos recientes</td>
                    </tr>
                }
                {data?.reduce((acc, fila) => {
                    if (fila.spacesIn > 0 && (tipoFiltro === 'Todos' || tipoFiltro === 'Entradas')) {
                        acc.push({...fila, isIN: true});
                    }
                    if (fila.spacesOut > 0 && (tipoFiltro === 'Todos' || tipoFiltro === 'Salidas')) {
                        acc.push({...fila, isIN: false});
                    }
                    return acc;
                }, []).map((fila, i)=>{
                    console.log(fila)
                    let auxFecha = formatoFechaCorta(new Date(fila?.mainDate?.split("T")[0].split("-")));
                    if(auxFecha == formatoFechaCorta(new Date())){
                        auxFecha = "Hoy";
                    }
                    console.log(estatus, fila.status)
                    const isIN = fila.isIN;
                    return(
                        <tr key={i} onClick={()=>{
                            setId(fila.idInout);
                        }}>
                            <td>
                                <div className="cliente">
                                    {fila?.Photos?.[0]?.url &&
                                        <span className="imgPerfil">
                                            <img src={fila?.Photos?.[0]?.url}/>
                                        </span>
                                    }
                                    <span>{fila.name}</span>
                                </div>
                            </td>
                            <td>
                                <div className="cliente">
                                    {fila?.url &&
                                        <span className="imgPerfil">
                                            <img src={fila.url}/>
                                        </span>
                                    }
                                    <span>{fila.nameUser+ " " +fila.lastname}</span>
                                </div>
                            </td>
                            <td>${formatoMoneda(fila.price*1)}</td>
                            <td>
                                <span className={fila.status}>
                                    <span>{estatus[fila.status]}</span>
                                    <img src={imgEstatus[fila.status]}/>
                                </span>
                            </td>
                            <td>{isIN ? "ENTRADA" : "SALIDA"}</td>
                            <td>{isIN ? fila?.spacesIn : fila?.spacesOut}</td>
                            <td>{formatoFechaCorta(new Date(fila.date.split("T")[0].split("-")))}</td>
                            <td>{fila?.time}</td>
                        </tr>
                    )
                })
                }
            </tbody>
        </table>
    )
}

const Calendario = ({ data, setId }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(null);

    const daysInMonth = (month, year) => new Date(year, month + 1, 0).getDate();

    const handlePrevMonth = () => {
        setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() - 1)));
    };

    const handleNextMonth = () => {
        setCurrentDate(new Date(currentDate.setMonth(currentDate.getMonth() + 1)));
    };

    const handlePrevYear = () => {
        setCurrentDate(new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)));
    };

    const handleNextYear = () => {
        setCurrentDate(new Date(currentDate.setFullYear(currentDate.getFullYear() + 1)));
    };

    const getReservationsForDay = (day) => {
        return data.filter(reservation => {
            const reservationDate = new Date(reservation.date);
            return reservationDate.getDate() === day &&
                   reservationDate.getMonth() === currentDate.getMonth() &&
                   reservationDate.getFullYear() === currentDate.getFullYear();
        });
    };

    const renderCalendar = () => {
        const days = [];
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).getDay();
        const daysInCurrentMonth = daysInMonth(currentDate.getMonth(), currentDate.getFullYear());
        const today = new Date();

        // Fill in the days from the previous month
        for (let i = 0; i < firstDayOfMonth; i++) {
            days.push(<div key={`empty-${i}`} className="cal-day empty"></div>);
        }

        // Fill in the days of the current month
        for (let i = 1; i <= daysInCurrentMonth; i++) {
            const isToday = i === today.getDate() && 
                                currentDate.getMonth() === today.getMonth() && 
                                currentDate.getFullYear() === today.getFullYear();
            const reservations = getReservationsForDay(i);
            const isSelected = selectedDate === i;
            days.push(
                <div key={i} className={`cal-day${isToday ? ' today' : ''}${isSelected ? ' selected' : ''}`} onClick={() => setSelectedDate(i)}>
                    <span>{i}</span>
                    {reservations.length > 0 && <span className="cal-dot" title={`${reservations.length} in/out`}></span>}
                </div>
            );
        }

        return days;
    };

    return (
        <div className="cal-wrapper">
            <div className="cal-panel">
                <div className="cal-header">
                    <div className="cal-nav">
                        <button onClick={handlePrevYear} title="Año anterior">
                            <svg viewBox="0 0 24 24"><polyline points="11 17 6 12 11 7"/><polyline points="18 17 13 12 18 7"/></svg>
                        </button>
                        <button onClick={handlePrevMonth} title="Mes anterior">
                            <svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
                        </button>
                    </div>
                    <span className="cal-title">
                        {currentDate.toLocaleString('es-MX', { month: 'long' }).charAt(0).toUpperCase() + currentDate.toLocaleString('es-MX', { month: 'long' }).slice(1)}
                        <small>{currentDate.getFullYear()}</small>
                    </span>
                    <div className="cal-nav">
                        <button onClick={handleNextMonth} title="Próximo mes">
                            <svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"/></svg>
                        </button>
                        <button onClick={handleNextYear} title="Próximo año">
                            <svg viewBox="0 0 24 24"><polyline points="13 17 18 12 13 7"/><polyline points="6 17 11 12 6 7"/></svg>
                        </button>
                    </div>
                </div>
                <div className="cal-grid">
                    {['D','L','M','X','J','V','S'].map(d => (
                        <div key={d} className="cal-dayname">{d}</div>
                    ))}
                    {renderCalendar()}
                </div>
            </div>
            {selectedDate && (
                <div className="cal-detail">
                    <div className="cal-detail-header">
                        <span>{selectedDate} de {currentDate.toLocaleString('es-MX', { month: 'long' })}</span>
                        <button className="cal-close" onClick={() => setSelectedDate(null)}>
                            <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                        </button>
                    </div>
                    <ul className="cal-events">
                        {getReservationsForDay(selectedDate).length === 0 && (
                            <li className="cal-empty">Sin eventos</li>
                        )}
                        {getReservationsForDay(selectedDate).map((reservation, index) => (
                            <li key={index} onClick={() => setId(reservation.id)} className="cal-event-item">
                                <span className="cal-event-time">{reservation.time}</span>
                                <span className="cal-event-name">{reservation.nameUser} {reservation.lastname}</span>
                                <span className={`cal-event-status ${reservation.status}`}>
                                    <img src={imgEstatus[reservation.status]} alt=""/>
                                    {estatus[reservation.status]}
                                </span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

const FiltrarImporte = ({setShowFilter, showFilter, filtros, setFiltros, modFiltrar})=>{
    const [tipo, setTipo] = useState(filtros?.price?.cond || 0);
    const value1 = useRef();
    const value2 = useRef();

    useEffect(()=>{
        value1.current.value = filtros?.price?.values[0];
        if(value2?.current)
            value2.current.value = filtros?.price?.values[1];
    }, [filtros])

    const aplicarFiltros = ()=>{
        if(!(
            value1?.current?.reportValidity() &&
            (!value2?.current || value2?.current?.reportValidity())
        )){
            return false;
        }

        setFiltros(filtros=> {
            return {...filtros, price: {
                cond: tipo,
                values: [value1.current.value, value2?.current?.value]
            }}
        })

        setShowFilter(false);
    }
    return(
        <div className="modFiltrar" ref={modFiltrar}>
            <h3>Filtrar por Importe</h3>
            <div>
                <select value={tipo} onChange={(e)=>{
                    setTipo(e.target.value)
                }}>
                    <option value='0'>Igual a</option>
                    <option value='1'>Entre </option>
                    <option value='2'>Mayor que</option>
                    <option value='3'>Menor que</option>
                </select>
            </div>
            <div className="defineRango">
                <label className="rango">
                    <img src={FlechaGuia}/>
                    <input type="number" ref={value1} required/>
                </label>
                {tipo == '1' &&
                    <>
                        <span className="guion"> — </span>
                        <label className="rango">
                            <input type="number" ref={value2} required/>
                        </label>
                    </>
                }
            </div>
            <div>
                <button className="btn" onClick={aplicarFiltros}>Aplicar</button>
            </div>
        </div>
    )
}

const FiltrarEstatus = ({setShowFilter, filtros, setFiltros, modFiltrar})=>{
    
    const [selected, setSelected] = useState(filtros?.statuses || []);
    
    const aplicarFiltros = ()=>{
        if(selected.length === 0){
            setFiltros(filtros=> {
                return {...filtros, statuses: undefined}
            })
        }
        else{
            setFiltros(filtros=> {
                return {...filtros, statuses: selected}
            })
        }

        setShowFilter(false);
    }

    return(
        <div className="modFiltrar" ref={modFiltrar}>
            <h3>Filtrar por Estatus</h3>
            <div className="lista">
                {Object.keys(estatus).map(x=>{
                    console.log(selected, x);
                    return(
                        <label key={x}>
                            <input type="checkbox" checked={selected.includes(x)} onChange={(e)=>{
                                if(selected.includes(x)){
                                    selected.splice(selected.indexOf(x), 1)
                                    setSelected([...selected])
                                }
                                else{
                                    selected.push(x)
                                    setSelected([...selected])
                                }
                            }}/>
                            <span>{estatus[x]}</span>
                        </label>
                    )
                })
                }
            </div>
            <div>
                <button className="btn" onClick={aplicarFiltros}>Aplicar</button>
            </div>
        </div>
    )
}
const FiltrarFecha = ({setShowFilter, showFilter, filtrosDates, setFiltros, modFiltrar})=>{
    console.log(filtrosDates)
    const [tipo, setTipo] = useState(filtrosDates?.cond || 4);
    const value1 = useRef();
    const value2 = useRef();
    const select = useRef();

    useEffect(()=>{
        if(filtrosDates?.cond < 4){
            value1.current.value = filtrosDates?.values[0];
            if(value2?.current)
                value2.current.value = filtrosDates?.values[1];
        }
        else{
            value1.current.value = 10;
        }
    }, [filtrosDates])

    const aplicarFiltros = ()=>{
        if(!(
            value1?.current?.reportValidity() &&
            (!value2?.current || value2?.current?.reportValidity())
        )){
            return false;
        }
        if(tipo < 4){
            setFiltros(filtros=> {
                if(showFilter == "FechaI")
                    return {...filtros, startDates: {
                    cond: tipo,
                    values: [value1.current.value, value2?.current?.value]
                }}

                return {...filtros, endDates: {
                    cond: tipo,
                    values: [value1.current.value, value2?.current?.value]
                }}
            })
        }
        else{
            const aux = [];
            
            const hoy = new Date();
            const auxDate = new Date();
            const intervalo = value1.current.value*1 || 1;

            if(tipo == 4){
                if(select.current.value == 'Días'){
                    auxDate.setDate(auxDate.getDate() - intervalo);
                }
                else if(select.current.value == 'Meses'){
                    auxDate.setMonth(auxDate.getMonth() - intervalo);
                }
                else if(select.current.value == 'Meses'){
                    auxDate.setFullYear(auxDate.getFullYear() - intervalo);
                }
                aux.push(formatoFecha(auxDate))
                aux.push(formatoFecha(hoy))
            }
            else{
                if(select.current.value == 'Días'){
                    auxDate.setDate(auxDate.getDate() + intervalo);
                }
                else if(select.current.value == 'Meses'){
                    auxDate.setMonth(auxDate.getMonth() + intervalo);
                }
                else if(select.current.value == 'Años'){
                    auxDate.setFullYear(auxDate.getFullYear() + intervalo);
                }
                aux.push(formatoFecha(hoy))
                aux.push(formatoFecha(auxDate))
            }
            console.log(aux);
            setFiltros(filtros=> {
                if(showFilter == "FechaI")
                    return {...filtros, startDates: {
                    cond: tipo,
                    values: aux,
                    tiempo: select.current.value,
                    intervalo
                }}

                return {...filtros, endDates: {
                    cond: tipo,
                    values: aux,
                    tiempo: select.current.value,
                    intervalo
                }}
            })
        }

        setShowFilter(false);
    }
    return(
        <div className="modFiltrar" ref={modFiltrar}>
            <h3>Filtrar por Fecha</h3>
            <div>
                <select value={tipo} onChange={(e)=>{
                    setTipo(e.target.value)
                }}>
                    <option value='4'>En los últimos</option>
                    <option value='5'>En los próximos</option>
                    <option value='0'>Igual a</option>
                    <option value='1'>Entre </option>
                    <option value='2'>Despues de</option>
                    <option value='3'>Antes de</option>
                </select>
            </div>
            <div className="defineRango">
                {tipo <= 3 &&
                    <>
                        <label className="rango">
                            <img src={FlechaGuia}/>
                            <input type="date" ref={value1} required/>
                        </label>
                        {tipo == '1' &&
                            <>
                                <span className="guion"> — </span>
                                <label className="rango">
                                    <input type="date" ref={value2} required/>
                                </label>
                            </>
                        }
                    </>
                }
                {tipo > 3 &&
                    <label className="rango">
                        <img src={FlechaGuia}/>
                        <input type="number" ref={value1} min={1} required/>
                        <select ref={select}>
                            <option>Días</option>
                            <option>Meses</option>
                            <option>Años</option>
                        </select>
                    </label>
                }
            </div>
            <div>
                <button className="btn" onClick={aplicarFiltros}>Aplicar</button>
            </div>
        </div>
    )
}

export default DashInouts;